import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "@redux/hooks";
import { resetUpdatePassword, updatePassword } from "../../../write/application/use-cases/password-update/update-password";
import { useApiAction } from "@shared-kernel/primary/shared/api-errors/use-api-action";
import { applyApiFieldErrors } from "@shared-kernel/primary/shared/api-errors/apply-api-field-errors";
import type { ActionForm } from "@shared-kernel/primary/shared/api-errors/action-form";
import { useResetWhenSettled } from "@shared-kernel/primary/shared/request-state/use-reset-when-settled";
import { selectPasswordUpdate } from "@user-management-context/write/application/use-cases/password-update/selectors/password-update-selectors";
import type { FormInputs } from "../shared/password-form/form-validation/user-password.schema";

export const usePasswordUpdate = (form: ActionForm<FormInputs>, userId: string, token: string) => {
  const navigate = useNavigate();
  const run = useApiAction();
  const { processing } = useAppSelector(selectPasswordUpdate);
  useResetWhenSettled(processing, resetUpdatePassword);

  // L'API dit pourquoi le mot de passe est refusé (lien expiré ou remplacé), sous le champ désigné
  const update = useCallback(
    async (values: FormInputs) => {
      const outcome = await run(updatePassword({ ...values, userId, token }), {
        success: "Mot de passe mis à jour !",
        failure: "Erreur lors de la mise à jour du mot de passe. Veuillez contacter l'administrateur",
      });
      if (!outcome.ok) {
        applyApiFieldErrors(form, outcome.error);
        return;
      }
      navigate(`/login`);
    },
    [run, navigate, form, userId, token],
  );

  return { update };
};
